import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=c4864272&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=c4864272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports